import { render, staticRenderFns } from "./ContainerWedding.vue?vue&type=template&id=f6670f38&scoped=true"
import script from "./ContainerWedding.vue?vue&type=script&lang=js"
export * from "./ContainerWedding.vue?vue&type=script&lang=js"
import style0 from "./ContainerWedding.vue?vue&type=style&index=0&id=f6670f38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6670f38",
  null
  
)

export default component.exports